var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1814",
    "data-name": "Grupo 1814",
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.174,
    height: 47.162,
    viewBox: "0 0 173.174 47.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1743",
    "data-name": "Grupo 1743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    "data-name": "Caminho 422",
    d: "M46.848,20.355a.314.314,0,0,0,.314-.314v-2.2a.314.314,0,0,0-.314-.314h-5.78a1.415,1.415,0,0,0-1,.414l-3.911,3.911h-8.4L37.89,11.715a.315.315,0,0,0,0-.444l-2-2a.314.314,0,0,0-.444,0L25.309,19.409V11L29.22,7.094a1.415,1.415,0,0,0,.414-1V.314A.314.314,0,0,0,29.32,0h-2.2a.314.314,0,0,0-.314.314V5.509L23.581,8.734,20.356,5.509V.314A.314.314,0,0,0,20.041,0h-2.2a.314.314,0,0,0-.314.314v5.78a1.415,1.415,0,0,0,.414,1L21.853,11v8.4L11.715,9.272a.314.314,0,0,0-.444,0l-2,2a.314.314,0,0,0,0,.444L19.409,21.853H11L7.094,17.942a1.415,1.415,0,0,0-1-.414H.314A.314.314,0,0,0,0,17.842v2.2a.314.314,0,0,0,.314.314H5.509l3.225,3.225L5.509,26.806H.314A.314.314,0,0,0,0,27.12v2.2a.314.314,0,0,0,.314.314h5.78a1.415,1.415,0,0,0,1-.414L11,25.309h8.4L9.272,35.446a.314.314,0,0,0,0,.444l2,2a.314.314,0,0,0,.444,0L21.853,27.752v8.4l-3.911,3.911a1.415,1.415,0,0,0-.414,1v5.78a.314.314,0,0,0,.314.314h2.2a.314.314,0,0,0,.314-.314V41.653l3.225-3.225,3.225,3.225v5.195a.314.314,0,0,0,.314.314h2.2a.314.314,0,0,0,.314-.314v-5.78a1.414,1.414,0,0,0-.414-1l-3.911-3.911v-8.4l10.36,10.36,2.444-2.444-10.36-10.36h8.4l3.911,3.911a1.413,1.413,0,0,0,1,.414h5.78a.314.314,0,0,0,.314-.314v-2.2a.314.314,0,0,0-.314-.314H41.653l-3.225-3.226,3.225-3.225Zm-23.267,5.6-2.373-2.373,2.373-2.373,2.373,2.373Z",
    fill: "#a6ff00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1744",
    "data-name": "Grupo 1744",
    transform: "translate(57.456 9.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_423",
    "data-name": "Caminho 423",
    d: "M351.111,65.825c0,5.287-3.525,8.812-10.77,8.812H328.788v9.791h-3.916V57.013h15.469C347.586,57.013,351.111,60.538,351.111,65.825Zm-4.112,0c0-2.937-2.154-5.091-6.658-5.091H328.788V70.916h11.553C344.845,70.916,347,68.762,347,65.825Z",
    transform: "translate(-324.872 -56.23)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    "data-name": "Caminho 424",
    d: "M488.98,90.229H492.9v3.446h.2a7.99,7.99,0,0,1,6.462-3.446h2.193V93.95h-2.193c-5.483,0-6.658,3.211-6.658,3.211v14.608H488.98Z",
    transform: "translate(-459.956 -83.571)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_425",
    "data-name": "Caminho 425",
    d: "M563.781,99.176c0-6.266,4.9-11.161,13.119-11.161s13.119,4.9,13.119,11.161-4.9,11.161-13.119,11.161S563.781,105.442,563.781,99.176Zm22.323,0c0-4.7-3.133-7.832-9.2-7.832s-9.2,3.133-9.2,7.832,3.133,7.833,9.2,7.833S586.1,103.876,586.1,99.176Z",
    transform: "translate(-521.528 -81.749)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_426",
    "data-name": "Caminho 426",
    d: "M714.713,59.243h4.308c0-4.112,2.546-6.658,6.658-6.658h11.553v3.329H726.07c-1.958,0-3.133,1.175-3.133,3.329h14.49V80.782h-3.916V62.571H722.937V80.782h-3.916V62.571h-4.308Z",
    transform: "translate(-645.767 -52.585)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    "data-name": "Caminho 427",
    d: "M857.384,108.44l15.665-14.49v-.2H857.58V90.229h20.756v3.329l-15.665,14.49v.2h16.253v3.525H857.384Z",
    transform: "translate(-763.205 -83.571)",
    fill: "#a6ff00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c58b4e2d8031a09507a4ca840447971a.svg";
export { ForwardRef as ReactComponent };